// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__25cr9","col":"styles_col__lAdkM"};